import { useLocation, useNavigate } from 'react-router-dom';

import LogoutIcon from '../../assets/Icons/navigation-icon/LogoutIcon';
import LogoutModal from './LogoutModal';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import { logout } from '../../slices/auth.slice';
import { sideBarContentAdmin } from './Sidebar.data';
import styles from './Sidebar.module.scss';
import { useAppDispatch } from '../../store/hooks';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { selectIsCompact } from '../../slices/compact.slice';
const Sidebar = () => {
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isCompact = useSelector(selectIsCompact);
  const handleLogoutModal = () => {
    setOpenLogoutModal(true);
  };

  const handleLogoutClick = () => {
    setOpenLogoutModal(false);
    dispatch(logout());
    navigate('/login');
  };

  const onSidebarNavClick = (pageRoute: string) => {
    if(pageRoute) {
      navigate(pageRoute);
    }
  };
  const sideBarContentClassName = (page: string) => {
    if (location.pathname === page) {
      return styles.activeLink;
    }
    return styles.inactiveLink;
  };

  const openInNewTab = (url: string | undefined): void => {
    if (url) {
      const newWindow = window.open(url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    }
  };

  return (
    <div className={styles.sidenavWrapper}>
      <div
        className={isCompact ? styles.sideBarCompact : styles.sideBarExtended}
      >
        <ul className={isCompact ? styles.compactList : styles.extendedList}>
          {isCompact
            ? sideBarContentAdmin.map(
                (listItem: {
                  id: number;
                  pageRoute: string;
                  sideNavIcon: JSX.Element;
                  activeSideNavIcon: JSX.Element;
                  pageName: string;
                  page: string;
                  externalLink?: string;
                }) => {
                  return (
                    <li key={listItem.id}>
                      <Tooltip
                        title={listItem.pageName}
                        arrow
                        placement="right"
                        slotProps={{
                          popper: {
                            modifiers: [
                              {
                                name: "offset",
                              },
                            ],
                          },
                        }}
                        TransitionComponent={Zoom}
                      >
                        <span
                          className={
                            listItem.externalLink
                              ? styles.navLink
                              : sideBarContentClassName(listItem.page)
                          }
                          onKeyDown={() => {}}
                          onClick={() =>
                            listItem.externalLink
                              ? openInNewTab(listItem.externalLink)
                              : onSidebarNavClick(listItem.pageRoute)
                          }
                        >
                          {location.pathname.includes(listItem.page)
                            ? listItem.activeSideNavIcon
                            : listItem.sideNavIcon}
                        </span>
                      </Tooltip>
                    </li>
                  );
                }
              )
            : sideBarContentAdmin?.map(
                (listItem: {
                  id: number;
                  pageRoute: string;
                  sideNavIcon: JSX.Element;
                  activeSideNavIcon: JSX.Element;
                  pageName: string;
                  page: string;
                  externalLink?: string;
                }) =>
                  listItem.externalLink ? (
                    <li
                      key={listItem.id}
                      onClick={() => openInNewTab(listItem.externalLink)}
                    >
                      <span className={styles.navLink}>
                        {listItem.sideNavIcon}
                      </span>
                      <span className={styles.inactiveLink}>
                        {listItem.pageName}
                      </span>
                    </li>
                  ) : (
                    <li
                      key={listItem.id}
                      onKeyDown={() => {}}
                      onClick={() => onSidebarNavClick(listItem.pageRoute)}
                    >
                      <span className={sideBarContentClassName(listItem.page)}>
                        {location.pathname.includes(listItem.page)
                          ? listItem.activeSideNavIcon
                          : listItem.sideNavIcon}
                      </span>
                      <span className={sideBarContentClassName(listItem.page)}>
                        {listItem.pageName}
                      </span>
                    </li>
                  )
              )}
        </ul>
        <ul
          className={
            isCompact
              ? styles.sidebarBelowcompactList
              : styles.sidebarBelowextendedList
          }
        >
          {isCompact ? (
            <>
              <li>
                <Tooltip
                  title="Logout"
                  arrow
                  placement="right"
                  slotProps={{
                    popper: {
                      modifiers: [
                        {
                          name: "offset",
                        },
                      ],
                    },
                  }}
                  TransitionComponent={Zoom}
                >
                  <span
                    onClick={() => handleLogoutModal()}
                    onKeyDown={() => {}}
                  >
                    <LogoutIcon color={"#cccccc"} />
                  </span>
                </Tooltip>
              </li>
            </>
          ) : (
            <>
              <li>
                <span>
                  <LogoutIcon color={"#cccccc"} />
                </span>
                <span
                  onClick={() => handleLogoutModal()}
                  onKeyDown={() => {}}
                  style={{ color: "#cccccc" }}
                >
                  Logout
                </span>
              </li>
            </>
          )}
        </ul>
      </div>
      {openLogoutModal && (
        <LogoutModal
          open={openLogoutModal}
          handleCancel={() => setOpenLogoutModal(false)}
          handleLogoutClick={handleLogoutClick}
        />
      )}
    </div>
  );
};

export default Sidebar;
